import { uploadRemoteAnimation  } from '@/gql/Queries.js';

function ImportHelper(api, $apollo, timelimit = 60) {
  this.api = api;
  this.$apollo = $apollo;

  this.timelimit = 60;

  this.delayBetweenChecks = 1000;
  // just a secondary max counter to block if any other errors
  // at 500ms this makes the max bail out if all else fails
  this.MAX_TIMES = this.timelimit * (1000/this.delayBetweenChecks) + 5;
}

ImportHelper.prototype.destroy = function () {
  this.destroyed = true;
}

ImportHelper.prototype.waitFor = async function (importId) {
  let i = 0;
  return new Promise( (resolve, reject) => {
    console.log('wait for', importId);
    let startTime = new Date().getTime();
    const waitForFile = async () => {
      if (i > this.MAX_TIMES || this.destroyed) {
        return;
      }
      i++;
      try {
        const url = this.api.makeImportDataUrl(importId, 't=' + new Date().getTime());
        console.log('have url for import data', url);
        try {
          const data = await fetch(url, {
            method: 'HEAD',
            mode: 'cors',
            cache: 'no-cache'
          });
          const blob = await data.blob();

          console.log('data', data.status, 'blob type', blob, blob.type);
          if (data.status !== 200 || blob.type === "text/html" /* because of SPA redirect to index.html */) {
            let currentTime = new Date().getTime();
            if (currentTime - startTime > this.timelimit * 1000) {
              // error
              reject(`Oops! Cannot process file..`);
            } else {
              setTimeout(waitForFile, this.delayBetweenChecks);
            }
          } else {
            try {
              const data = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache'
              });
              const json = await data.json();
              resolve(json);
            } catch (e) {
              reject(e);
            }
          }
        } catch (e) {
          console.error(e);
          setTimeout(waitForFile, this.delayBetweenChecks);
        }

      } catch (e) {
        reject(e);
      }
    }


    setTimeout(waitForFile, 10);

  });

}

ImportHelper.prototype.waitForUpload = async function (id) {
  console.log('wait for import data', id);
  const waitingData = await this.waitFor(id);

  this.isProcessing = false;
  console.log('have waiting data', waitingData);
  return waitingData;
}

ImportHelper.prototype.importAnimation = async function (url) {
  const importData = await this.$apollo.mutate({
    mutation:uploadRemoteAnimation,
    variables:{
      url
    },
    context: {
      timeout: 60 * 1000
    },
    error(error) {
      console.log('there is error', error);
      this.processingError = JSON.stringify(error.message);
      throw error;
    }
  });

  console.log('have import data', importData);
  const waitingData = await this.waitFor(importData.data.uploadRemoteAnimation.importId);

  this.isProcessing = false;
  console.log('uploadedAnimation', waitingData);
  return waitingData;
}
export default ImportHelper;
